import(/* webpackMode: "eager", webpackExports: ["PageClientImpl"] */ "/opt/prowel-livekit/web/app/rooms/[roomName]/PageClientImpl.tsx");
